// 图片上传错误类型
export enum ERROR_TYPE {
    'SIZE' = 'SIZE', // 大小
    'RECT' = 'RECT', // 尺寸宽高
    'TYPE' = 'TYPE', // 图片格式
    'RATIO' = 'RATIO', // 宽高比例
    'CUSTOMIZE' = 'CUSTOMIZE' // 自定义
}
